export async function loadHistoricJobRecords(supabase, workshopId) {
  const rows = []
  const pageSize = 500
  for (let offset = 0; offset < 20000; offset += pageSize) {
    const { data, error } = await supabase.from('legacy_historic_job_records').select('*')
      .eq('workshop_id', workshopId).order('created_at', { ascending: false })
      .order('id', { ascending: false }).range(offset, offset + pageSize - 1)
    if (error) throw error
    rows.push(...(data || []))
    if (!data || data.length < pageSize) return rows
  }
  throw new Error('Historical job list exceeded the safe page limit. No rows were silently omitted.')
}

export function historicalJobSearch(record, query) {
  const q = String(query || '').trim().toLowerCase()
  if (!q) return true
  const facts = record.facts || {}
  return [record.source_reference, record.source_system, facts.customer, facts.first_name,
    facts.last_name, facts.bikes, facts.assigned_mechanic, facts.status, facts.invoice_status,
    facts.invoice_number, facts.invoice_items, facts.historical_amount]
    .some(value => String(value || '').toLowerCase().includes(q))
}
